<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="id" label="任务ID" width="auto" />
      <el-table-column prop="name" label="H5标题" width="auto" />
      <el-table-column prop="time" label="创建日期" width="auto">
        <template v-slot="{row}">
          {{ row.createTime?formatTime(row.createTime):"--" }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="handleEdit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="handleCopy(row)">复制</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="fixed-below" background :current-page.sync="currentPage.current" :page-sizes="currentPage.sizes" :page-size="currentPage.limit" layout="total, prev, pager, next, sizes" :total="currentPage.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
  </div>
</template>

<script>
import Dialog from '@/components/Dialog';
import moment from 'moment';
export default {
  components: { Dialog },
  data() {
    return {
      search: {
        name: "",
      },
      list: [],
      formDialogShow: false,
      currentID: -1,
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
    };
  },
  mounted() {
    // 获取列表数据
    this.getGoodsList();
  },
  methods: {
    getGoodsList() {
      this.$Api.h5landing.postLandingPageList({ ...this.currentPage }).then(res => {
        if (res) {
          this.list = res.data;
          this.currentPage.total = res.total;
        }
      });
    },
    add() {
      this.$router.push({ path: '/toolbox/h5LandingPage/add' });
    },
    searchSubmit() {
      this.$Api.h5landing.postLandingPageList({ ...this.currentPage, name: this.search.name }).then(res => {
        if (res) {
          this.list = res.data;
          this.currentPage.total = res.total;
        }
      });
    },
    reset() {
      this.search.name = "";
      this.getGoodsList();
    },
    handleEdit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑H5落地页列表ID为“${this.currentID}”的数据项？`,
      };
    },
    handleCopy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    submitSucces(operation) {
      if (operation === 'copy') {
        this.$router.push({ path: '/toolbox/h5LandingPage/add', query: { copyid: this.currentID } });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/toolbox/h5LandingPage/add', query: { id: this.currentID } });
      }
    },
    formatTime(val) {
      if (val) return moment(val).format('YYYY/MM/DD HH:mm:ss');
      return '';
    },
    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getGoodsList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getGoodsList();
    },
  },
};
</script>

<style>
</style>
